import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { AccessListUserByCustomerNumberData } from '@vi-iot/client/index';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-access-list-user',
  standalone: true,
  imports: [CommonStandaloneModule, NgFor, RouterModule, MatExpansionModule],
  templateUrl: './access-list-user.component.html',
  styleUrl: './access-list-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessListUserComponent {
  @Input() userData: AccessListUserByCustomerNumberData;
}
